<template>
  <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3">
    <generalForm typeForm="date" :variableData="variableDataComponent">
      <template v-slot="{}">
        <b-tab id="obs1" title="Tipo de Campo" class="px-1">
          <ValidationObserver ref="obs1">
            <b-card class="card-form shadow">
              <div class="row">
                <div class="col-md-6 col-lg-4 radio-group">
                  <InputRadio
                    id="fromToday"
                    name="fromToday"
                    label="Desde fecha actual"
                    type="number"
                    validate="required"
                    :options="[
                      { value: 0, text: 'No' },
                      { value: 1, text: 'Si' },
                    ]"
                    :value.sync="variableDataComponent.config.fromToday"
                  />
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 date">
                  <label>Fecha Mínima</label>
                  <InputDatepicker
                    id="minimunDate"
                    name="minimumDate"
                    v-model="variableDataComponent.config.minimunDate"
                    :validate="{
                      regex: /^(19[0-9]{2}|2[0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12]\d|3[0-1]))|(02-(0[1-9]|[12]\d))|((0[469]|11)-(0[1-9]|[12]\d|30)))$/,
                      required: variableDataComponent.config.fromToday
                        ? false
                        : true,
                    }"
                    :disabled="disableMinimumDate"
                  />
                </div>
              </div>
            </b-card>
          </ValidationObserver>
        </b-tab>
      </template>
    </generalForm>
  </div>
</template>
<script>
import generalForm from '@/src/components/variables/general-form'
import InputRadio from '@components/form/InputRadio'
import InputDatepicker from '@components/form/InputDatepicker'
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'dateComponent',
  components: {
    generalForm,
    InputRadio,
    //VueCtkDateTimePicker,
    InputDatepicker,
  },
  props: {
    variableDataComponent: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      defaultConfig: {
        minimunDate: null,
        fromToday: null,
      },
      disableMinimumDate: false,
    }
  },
  mounted() {
    if (Object.keys(this.variableDataComponent.config).length === 0) {
      this.variableDataComponent.config = this.defaultConfig
    }
    if (this.variableDataComponent.config.fromToday === 1) {
      this.variableDataComponent.config.minimunDate = null
      this.disableMinimumDate = true
    } else {
      this.disableMinimumDate = false
    }
  },
  watch: {
    variableDataComponent: {
      deep: true,
      handler(newValue, oldValue) {
        if (this.variableDataComponent.config.fromToday === 1) {
          this.variableDataComponent.config.minimunDate = null
          this.disableMinimumDate = true
        } else {
          this.disableMinimumDate = false
        }
      },
    },
  },
}
</script>

<style lang="scss">
.date {
  .datepicker {
    min-width: 280px !important;
    max-width: 280px !important;
  }
  .field.sm .field-input {
    font-size: 0.85rem !important;
  }
  .field.has-error .field-input {
    padding-top: 0px !important;
  }
}
.radio-group label {
  font-weight: normal !important;
}
</style>
